// CalloutNode: <aside data-type="callout" data-callout="info|warn|success|danger|note">
// Lexical の ElementNode を継承して、HTML import/export 双方向に対応。

import { ElementNode, $applyNodeReplacement } from "lexical"

const ALLOWED_VARIANTS = ["info", "warn", "success", "danger", "note"]

export class CalloutNode extends ElementNode {
  static getType() { return "callout" }

  static clone(node) {
    return new CalloutNode(node.__variant, node.__key)
  }

  constructor(variant = "info", key) {
    super(key)
    this.__variant = ALLOWED_VARIANTS.includes(variant) ? variant : "info"
  }

  getVariant()       { return this.getLatest().__variant }
  setVariant(variant) {
    const self = this.getWritable()
    self.__variant = ALLOWED_VARIANTS.includes(variant) ? variant : "info"
  }

  // DOM 生成 (画面に出す)
  createDOM(_config) {
    const dom = document.createElement("aside")
    dom.setAttribute("data-type", "callout")
    dom.setAttribute("data-callout", this.__variant)
    return dom
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__variant !== this.__variant) {
      dom.setAttribute("data-callout", this.__variant)
    }
    return false  // 子ノードの差分は Lexical reconciler に任せる
  }

  // HTML import (DOMParser からの取り込み)
  static importDOM() {
    return {
      aside: (node) => {
        if (node.getAttribute("data-type") !== "callout") return null
        return {
          conversion: (el) => ({
            node: $createCalloutNode(el.getAttribute("data-callout") || "info")
          }),
          priority: 1,
        }
      },
    }
  }

  // HTML export ($generateHtmlFromNodes で使われる)
  exportDOM() {
    const el = document.createElement("aside")
    el.setAttribute("data-type", "callout")
    el.setAttribute("data-callout", this.__variant)
    return { element: el }
  }

  // JSON シリアライズ (EditorState の永続化用、Akebono では未使用だが標準実装)
  static importJSON(serialized) {
    return $createCalloutNode(serialized.variant)
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "callout",
      variant: this.__variant,
      version: 1,
    }
  }
}

export function $createCalloutNode(variant = "info") {
  return $applyNodeReplacement(new CalloutNode(variant))
}

export function $isCalloutNode(node) {
  return node instanceof CalloutNode
}
